import { createSearchParams, Filters } from "features/course-discovery/utils";

export function linkToAnonymousCourseDiscoveryPage() {
  return `/courses`;
}

export const linkToAnonymousCourseDiscoveryPageWithFilters = (
  filters: Filters,
  text?: string
): string => {
  return `${linkToAnonymousCourseDiscoveryPage()}?${createSearchParams(
    filters,
    text
  )}`;
};

export const linkToAnonymousCourseDiscoveryWithDefaultFilters = () =>
  linkToAnonymousCourseDiscoveryPageWithFilters({});
